import Vue from "vue";
import { find } from "lodash";
import * as api from "@/api";
import makeListingMixin from "@lab/store/vuexListingMixin";

export default makeListingMixin(
	"listingNotificationGroup",
	api.listingNotificationGroup
)({
	state: {},
	mutations: {
		updateNotification(state, { notificationgroupid, id, status }) {
			const todo = find(state.byID[notificationgroupid].notifications, {
				id
			});
			Vue.set(todo, "status", status);
		}
	},
	actions: {
		updateNotification(context, notification) {
			api.notifications("put", notification);
			context.commit("updateNotification", notification);
		}
	},
	getters: {}
});
